import axios from 'axios'
import store from '../store'
import { Message, MessageBox } from 'element-ui'
import { getToken} from '@/utils/auth'
import {setToken} from '@/utils/auth'

//创建axios实例
const service = axios.create({
  // baseURL:process.env.BASE_API,//api的base_url
  baseURL:process.env.VUE_APP_API_URL,
  timeout:15000,//请求超时
  withCredentials: false
})

//request拦截器
service.interceptors.request.use(config=>{
  if(getToken()){
    config.headers['Authorization']=getToken() //让每个请求携带自定义token
  }
  return config
},error=>{
  console.log("error",error)
  Promise.reject(error)
})



// response 拦截器
service.interceptors.response.use(
  response=>{
    var _this = this
    const res = response.data
    console.log("res",res)
    // console.log("res",res)
        if(res.code != 200&&(response.request.responseURL.indexOf("admin")>-1||response.request.responseURL.indexOf("login")>-1)){
        if(res.code == 401 ||(res.message&&res.message.indexOf("系统错误")>-1)){
          MessageBox.confirm(res.message+",可以取消留在页面或者重新登录","确定登出",{
            confirmButtonText:"重新登录",
            cancelButtonText:"取消",
            type:"warning"
          }).then(()=>{
            store.boundDispatch("Logout").then(()=>{
                _this.$router.replace({name:'login'}).then(()=>{
                  Message.success("请重新登录")
                  window.location.reload()
              },()=>{
                  Message.success("退出失败")
              })
            })
          })
          return;
        }else{
          Message({
            message:res.message,
            type:'error',
            duration:3*1000
          })
        }
        return Promise.reject(res)
      }
      var token = response.headers.authorization
      if(token!=null&&token!=undefined&&token!=""){
        setToken(token)//保存到本地
        console.log(store)
        store.default.commit('SET_ACCESSTOKEN',token)
      }
      return res
    },
      error=>{
        // 安全取值：error.response 可能不存在（DNS解析失败、网络不通、超时等）
        const res = error.response && error.response.data ? error.response.data : {}
        var ifLogout = localStorage.getItem("pLogout")
        if(ifLogout == 1){
          return Promise.reject(error)
        }
        localStorage.setItem("pLogout",1)
        // 无有效响应体且无业务错误信息，直接 reject 不弹框
        if((res.code==undefined||res.code==null)&&(!res.message||res.message.indexOf("系统错误")==-1)){
          return Promise.reject(error)
        }
        const responseURL = error.response && error.response.request && error.response.request.responseURL || ''
        // admin/login 相关接口：不弹框，由调用方（如login.vue）统一处理提示，避免重复
        if(responseURL.indexOf("admin")>-1||responseURL.indexOf("login")>-1){
          return Promise.reject(error)
        }
        // 其他admin接口：弹框提示业务错误
        if(res.code==401||(res.message&&res.message.indexOf("系统错误")>-1)){
          MessageBox.confirm(res.message==undefined?"身份错误,可以取消留在页面或者重新登录":res.message+",可以取消留在页面或者重新登录","确定登出",{
            confirmButtonText:"重新登录",
            cancelButtonText:"取消",
            type:"warning"
          }).then(()=>{
              store.default.dispatch("Logout").then(()=>{
                  window.location.href = '/#/admin/login'
                  Message.success("请重新登录")
                  return;
              },()=>{
                  Message.success("退出失败")
              })
            })
          }else{
            Message({
              message:res.message,
              type:'error',
              duration:3*1000
            })
          }
        return Promise.reject(error)
    }
)

export default service